export default "__VITE_ASSET__c9048309__"